import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

export const tooltipText: (
	message: {
		message: string;
		values?: { pod_type?: string; button_id?: number };
	},
	boolean,
) => string = (message, disabled) => {
	return disabled ? get(format)(message.message, { values: { ...message.values } }) : '';
};
//using this function to dynamically change tooltip text on btn types and power on default components
